module.exports = __webpack_public_path__ + "img/hr-wooden-particle-09.0331c907.png";